import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { LinkButton } from '@/components/ui/Button/LinkButton';
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
import { ContentContainer } from '@/components/ui/Layout/ContentContainer/ContentContainer';
import { Card } from '@/components/ui/Surface/Card';
import { SmallTag } from '@/components/ui/Tag/SmallTag';
import Breadcrumb from '@/container/Layout/Breadcrumb';
import { useArrayWithIndex } from '@/hooks/array/useArrayWithIndex';
import { myPagePath, releaseListPath } from '@/utils/router/links';
/**
 * ニュース詳細 View 部分のコンポーネント
 * @param props
 * @returns
 */
export const ReleaseOneViewSkeleton = (props) => {
    const { isGuestUser } = props;
    /** パンくず設定 */
    const pans = useMemo(() => {
        const myPage = { link: myPagePath(), text: 'マイページ' };
        const common = [{ link: releaseListPath(), text: 'ニュース' }];
        return isGuestUser ? common : [myPage, ...common];
    }, [isGuestUser]);
    /** スケルトン表示用のダミー配列 */
    const dummies = useArrayWithIndex(4);
    return (_jsxs(_Fragment, { children: [_jsx(Breadcrumb, { lists: pans }), _jsxs(ContentContainer, Object.assign({ className: clsx('mx-auto mb-80'), maxWidthPoint: 'xl' }, { children: [_jsxs(Card, Object.assign({ className: clsx('pt-20 px-16 pb-32 lg:p-32', 'flex flex-col gap-y-20 lg:gap-y-32'), isShadow: true }, { children: [_jsx(Skeleton, { className: clsx('w-full h-[30px] lg:h-[51px]') }), _jsxs("div", Object.assign({ className: 'inline-flex items-center gap-x-20' }, { children: [_jsx(Skeleton, { className: clsx('w-[68px] h-[23px]') }), _jsx(SmallTag, Object.assign({ color: 'info' }, { children: _jsx(Skeleton, { className: clsx('w-[44px] h-[11px]') }) }))] })), _jsx("div", Object.assign({ className: 'flex flex-col gap-4' }, { children: dummies.map(({ index }) => (_jsx(Skeleton, { className: clsx('w-full h-[20px]') }, index))) })), _jsx(Skeleton, { className: clsx('w-[160px] h-[23px]') })] })), _jsx(LinkButton, Object.assign({ className: 'mt-28 mx-auto', color: 'gray', size: 'md', to: releaseListPath() }, { children: "\u30CB\u30E5\u30FC\u30B9\u4E00\u89A7\u3078\u623B\u308B" }))] }))] }));
};
